import { Component, Input } from '@angular/core';
import type { Sentence } from '@modules/process/pages/consent/models/sentence';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
})
export class ConditionsComponent {
  @Input() conditions!: Sentence;
}
